'use strict';

/* eslint no-undef: "off" */
/**
 * XPark video feature
 */
define('xparkVideoFeature',['xparkHomepageApi'], function (xparkHomepageApi) {
  return {
    template: '\n      <section class="xp-video-feature" v-if="hasContent || loading">\n        <div v-if="loading" class="skeleton-loading"></div>\n        <div class="xp-video-feature-card" v-if="hasContent">\n          <video\n            v-if="videoConfig.videoUrl"\n            class="xp-video-feature-media"\n            :src="videoConfig.videoUrl"\n            :poster="videoConfig.coverImage"\n            autoplay\n            loop\n            muted\n            playsinline\n            webkit-playsinline\n          ></video>\n\n          <a\n            v-else\n            class="xp-video-feature-cover"\n            :href="videoConfig.externalVideoUrl"\n            :aria-label="\'Play video\'"\n            target="_blank"\n            rel="noopener"\n          >\n            <img :src="videoConfig.coverImage" alt="" />\n            <span class="xp-video-play" aria-hidden="true"></span>\n          </a>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        videoConfig: {
          videoUrl: '',
          externalVideoUrl: '#',
          coverImage: ''
        },
        loading: true
      };
    },

    computed: {
      hasContent: function hasContent() {
        return Boolean(this.videoConfig.videoUrl || this.videoConfig.externalVideoUrl && this.videoConfig.coverImage);
      }
    },
    mounted: function mounted() {
      this.fetchBrandPromotion();
    },

    methods: {
      fetchBrandPromotion: function fetchBrandPromotion() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getBrandPromotion().then(function (data) {
          var video = data && data.brand_promotion;

          if (!video) {
            return;
          }

          _this.videoConfig = {
            videoUrl: video.video_url || '',
            externalVideoUrl: video.third_party_video_link || 'javascript:void(0);',
            coverImage: video.cover_image || ''
          };
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      }
    }
  };
});
